import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Splash from '../components/Splash';
import InstallPWAButton from '../components/InstallPWAButton';
import EventTeaser from '../components/EventTeaser';
import ArtistShowcase from '../components/ArtistShowcase';
import VideoHub from '../components/VideoHub';
import NewsSection from '../components/NewsSection';
import StoreSection from '../components/StoreSection';
import PartnersSection from '../components/PartnersSection';
import './Home.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

const DEFAULT_CONTENT = {
  hero_eyebrow: 'Independent Music Label',
  hero_title: 'Saskara Record',
  hero_desc: 'Rumah bagi musisi independen — dari studio ke panggung, dari rilisan ke merchandise.',
  artists_eyebrow: 'Roster',
  artists_title: 'Artis Kami',
  video_eyebrow: 'Video Hub',
  video_title: 'Terbaru dari Kami',
  news_eyebrow: 'Update',
  news_title: 'Berita Terbaru',
  events_eyebrow: 'Live & Event',
  events_title: 'Jadwal Terdekat',
  store_eyebrow: 'Merchandise',
  store_title: 'Saskara Store',
};

export default function Home() {
  const navigate = useNavigate();
  const [authDropdown, setAuthDropdown] = useState(null); // 'login' | 'register' | null
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/site-content/public`)
      .then((res) => {
        if (mounted && res.data.data) {
          setContent({ ...DEFAULT_CONTENT, ...res.data.data });
        }
      })
      .catch(() => {
        // fallback ke DEFAULT_CONTENT kalau API gagal
      });
    return () => {
      mounted = false;
    };
  }, []);

  const userInfo = JSON.parse(localStorage.getItem('saskara_user_info') || 'null');
  const handleLogout = () => {
    localStorage.removeItem('saskara_user_token');
    localStorage.removeItem('saskara_user_info');
    window.location.reload();
  };

  const chooseRole = (mode, role) => {
    setAuthDropdown(null);
    if (role === 'artist') {
      window.location.href = `https://artist.saskararecord.com/${mode}`;
    } else {
      navigate(`/${mode}`, { state: { skipChooser: true } });
    }
  };

  return (
    <>
      <Splash />
      <div className="home">
        <nav className="home-nav">
          <a href="/" className="home-nav__logo">
            <img src="/logo.png" alt="Saskara Record" className="home-nav__logo-img" />
            <span>SASKARA RECORD</span>
          </a>
          <div className="home-nav__links">
          <a href="#artists">Artis</a>
          <a href="#events">Event</a>
          <a href="/store">Store</a>
          <InstallPWAButton />
          {userInfo ? (
            <>
              <Link to="/account" className="home-nav__user" style={{ textDecoration: 'none' }}>Hai, {userInfo.name}</Link>
              <button className="home-nav__logout-btn" onClick={handleLogout}>Keluar</button>
            </>
          ) : (
            <div className="home-nav__auth-group">
              <div className="home-nav__auth-wrap">
                <button className="home-nav__auth-btn" onClick={() => setAuthDropdown(authDropdown === 'login' ? null : 'login')}>
                  Masuk
                </button>
                {authDropdown === 'login' && (
                  <div className="home-nav__dropdown">
                    <button onClick={() => chooseRole('login', 'fan')}>🎧 Sebagai Member</button>
                    <button onClick={() => chooseRole('login', 'artist')}>🎤 Sebagai Artis</button>
                  </div>
                )}
              </div>
              <div className="home-nav__auth-wrap">
                <button className="home-nav__auth-btn home-nav__cta" onClick={() => setAuthDropdown(authDropdown === 'register' ? null : 'register')}>
                  Daftar
                </button>
                {authDropdown === 'register' && (
                  <div className="home-nav__dropdown">
                    <button onClick={() => chooseRole('register', 'fan')}>🎧 Sebagai Member</button>
                    <button onClick={() => chooseRole('register', 'artist')}>🎤 Sebagai Artis</button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </nav>

      <section className="hero">
        <span className="hero__eyebrow">{content.hero_eyebrow}</span>
        <h1 className="hero__title">{content.hero_title}</h1>
        <p className="hero__desc">{content.hero_desc}</p>
      </section>

      <div id="artists">
        <ArtistShowcase eyebrow={content.artists_eyebrow} title={content.artists_title} />
      </div>

      <VideoHub eyebrow={content.video_eyebrow} title={content.video_title} />

      <NewsSection eyebrow={content.news_eyebrow} title={content.news_title} />

      <div id="events">
        <EventTeaser eyebrow={content.events_eyebrow} title={content.events_title} />
      </div>

      <StoreSection eyebrow={content.store_eyebrow} title={content.store_title} />

      <PartnersSection />

      <footer className="home-footer">
        <p>&copy; {new Date().getFullYear()} Saskara Record. All rights reserved.</p>
        <p style={{ marginTop: 8 }}>
          <Link to="/contact" style={{ color: '#C9A66B', textDecoration: 'none', marginRight: 16 }}>Kontak</Link>
          <Link to="/privacy-policy" style={{ color: '#C9A66B', textDecoration: 'none' }}>Kebijakan Privasi</Link>
        </p>
      </footer>
      </div>
    </>
  );
}
